import React from 'react';
import { Facebook, Phone, Mail } from 'lucide-react';
const PHONE = '586-203-3701';
const EMAIL = 'MoceriRS@gmail.com';
export function TopBar() {
  return <div className="w-full bg-[#3a3a3a] text-white text-sm" data-id="element-262">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2 flex flex-wrap items-center justify-between gap-2" data-id="element-263">
        <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:text-[#2DB8E0] transition-colors" data-id="element-264">
          <Facebook className="w-4 h-4 text-[#2DB8E0]" data-id="element-265" />
          <span className="font-medium" data-id="element-266">Follow Us On FB</span>
        </a>
        <div className="flex items-center gap-6" data-id="element-267">
          <a href={`tel:${PHONE.replace(/-/g, '')}`} className="hidden sm:flex items-center gap-2 hover:text-[#2DB8E0] transition-colors" data-id="element-268">
            <Phone className="w-4 h-4 text-[#2DB8E0]" data-id="element-269" />
            <span className="font-medium" data-id="element-270">{PHONE}</span>
          </a>
          <a href={`mailto:${EMAIL}`} className="flex items-center gap-2 hover:text-[#2DB8E0] transition-colors" data-id="element-271">
            <Mail className="w-4 h-4 text-[#2DB8E0]" data-id="element-272" />
            <span className="font-medium" data-id="element-273">{EMAIL}</span>
          </a>
        </div>
      </div>
    </div>;
}